import {
  SEND_REQUEST_REQUEST,
  SEND_REQUEST_SUCCESS,
  SEND_REQUEST_FAIL,
} from "../constants/AuthConstant";

const initialState = {
  loading: false,
  result: [],
  msg: "",
  error: "",
};

const SendRequestReducer = (state = initialState, action) => {
  switch (action.type) {
    case SEND_REQUEST_REQUEST:
      return {
        ...state,
        loading: action.payload,
      };
    case SEND_REQUEST_SUCCESS:
      return {
        ...state,
        result: action.result.data,
        loading: action.payload,
        msg: action.msg,
      };
    case SEND_REQUEST_FAIL:
      return {
        ...state,
        error: action.error,
        loading: action.payload,
        msg: action.msg,
      };

    default:
      return state;
  }
};

export default SendRequestReducer;
